<!--
  name : 김혜진
  desc : 계약작성
  date : 2021-08-04
-->
<template>
  <v-stepper v-model="e1" class="writeCpn_stepCon con_mpw">
    <!--step_header-->
    <div class="writeCpn_step_top">
      <v-stepper-header>
        <v-stepper-step id="Wstep01" :class="headerCSS(1)"
        >
          계약서 업로드
        </v-stepper-step>

        <v-stepper-step id="Wstep02" :class="headerCSS(2)"
        >
          계약요청 목록 확인
        </v-stepper-step>

        <v-stepper-step id="Wstep03" :class="headerCSS(3)"
        >
          계약요청
        </v-stepper-step>
      </v-stepper-header>
    </div>

    <!--step_con-->
    <v-stepper-items>

      <!--stepper-1-->
      <v-stepper-content step="1" :style="getDisplay(1)" id="write_S01">
        <step01 v-if="this.step === 1" ref="step01"></step01>
      </v-stepper-content>

      <!--stepper-2-->
      <v-stepper-content step="2" :style="getDisplay(2)" id="write_S02">
        <step02 v-if="this.step === 2" ref="step02"></step02>
      </v-stepper-content>

      <!--stepper-3-->
      <v-stepper-content step="3" :style="getDisplay(3)" id="write_S03">
        <step03 v-if="this.step === 3" ref="step03" ></step03>
      </v-stepper-content>

      <v-footer bottom class="steperF_btnCon justify-center">
        <v-btn class="btn19_00" v-if="step > 1" @click="previousStep"><span class="iconarr stP"></span>이전</v-btn>
        <v-btn class="btn19_C01" v-if="step === 1" @click="checkRegisteredEmployee">등록된 사원 확인<span class="iconarr stN"></span></v-btn>
        <v-btn class="btn19_C01" v-if="step === 1" @click="nextStep">업로드<span class="iconarr stN"></span></v-btn>
        <v-btn class="btn19_C01" v-if="step === 2" @click="nextStep">계약요청<span class="iconarr stN"></span></v-btn>
        <v-btn class="btn19_C01" v-if="step === 3" @click="nextStep">전송<span class="iconarr stN"></span></v-btn>
      </v-footer>

    </v-stepper-items>

  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  </v-stepper>
</template>
<script>
import step01 from '@/views/officeContract/contractCompany/components/step01'
import step02 from '@/views/officeContract/contractCompany/components/step02'
import step03 from '@/views/officeContract/contractCompany/components/step03'

export default {
  name: 'createOfficeContract',
  components: {
		step01,
		step02,
		step03,
  },
  filters: {
  },
  props:{
  },
  data () {
    return {
      // 스텝퍼
      e1: 1,
			step: 0,
    }
  },
  created () {
  },
  mounted () {
    this.step = 1
  },
  methods: {
    checkRegisteredEmployee() {
      this.$router.push( '/crew');
    },

    previousStep () {
      if(this.step === 2) {
        this.$refs.step02.deleteUploadedCtr()
        this.$store.dispatch('officeContractInfos', '')
      } else if (this.step === 3) {
        this.$store.dispatch("officeContractMetaStr",'')
      }
      this.step = this.step - 1
    },
    nextStep() {
      if(this.step === 1) {
        this.$refs.step01.submitUpload()
        this.loopSleep()
      } else if (this.step === 2) {
        this.$refs.step02.checkUploadCtrAndSubInfo()
        this.loopSleep()
      } else if (this.step === 3) {
        this.$refs.step03.submitAuthChain()
      }
    },
    addStep () {
      this.step = this.step + 1
    },
		stepGo(index) {
			this.step = index
		},
		getDisplay(index) {
			let CssName = ''
			if(this.step === index) {
				CssName = "display:block;"
			}else{
				CssName = "display:none;"
			}
			return CssName
		},
		headerCSS(index) {
			let CssName = ''

			if(this.step === index) {
				CssName = "on"
			}else{
				CssName = ""
			}
			return CssName
		},
    loopSleep () {
      setTimeout(() => {
        if(this.step === 1) {
          if (this.$store.state.app.officeContractInfos) {
            this.addStep()
          } else {
            this.loopSleep()
          }
        } else if (this.step === 2) {
          if (this.$store.state.app.officeContractMetaStr) {
            this.addStep()
          } else {
            this.loopSleep()
          }
        }
      }, 500)
    }
  }
}
</script>
<style>
/*write*/
.writeCpn_step_top {
    margin: auto;
    margin-top: 20px;
    width: 100%;
    border-bottom: 1px solid #d7d8da;
}

.writeCpn_stepCon.con_mpw {
    margin: 0px auto;
}

.writeCpn_stepCon .v-stepper__header {
    margin: 0 auto 20px;
    height: 50px;
    font-size: .85rem;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.writeCpn_stepCon .v-stepper__step {
    pointer-events: none;
    padding-top: 0;
    padding-bottom: 0;
}

.writeCpn_stepCon .v-stepper__step__step {
    width: 44px;
    height: 49px;
    background: url('../../../assets/img/writeCpn_stepCon_icon.png') no-repeat !important;
    text-indent: -9999px;
    background-color: transparent !important;
    border-radius: 0;
}

.writeCpn_stepCon #Wstep01 .v-stepper__step__step {
    background-position: 0px 0px !important;
}

.writeCpn_stepCon #Wstep02 .v-stepper__step__step {
    background-position: -44px 0px !important;
}

.writeCpn_stepCon #Wstep03 .v-stepper__step__step {
    background-position: -88px 0px !important;
}

.writeCpn_stepCon .on .v-stepper__step__step {
    background: url('../../../assets/img/writeCpn_stepCon_icon_on.png') no-repeat -0px 0px !important;
    background-color: transparent !important;
}

.writeCpn_stepCon #Wstep02.on .v-stepper__step__step {
    background-position: -44px 0px !important;
}

.writeCpn_stepCon #Wstep03.on .v-stepper__step__step {
    background-position: -88px 0px !important;
}

.writeCpn_stepCon .theme--light.v-stepper .v-stepper__step__step .v-icon {
    display: none;
}

.writeCpn_stepCon .v-stepper__items {
    margin: auto;
    width: 100%;
    height: calc(100% - 80px);
}
.writeCpn_stepCon .v-stepper__items>.v-stepper__content{
  padding: 0;
  height: calc(100% - 80px);
  overflow-y: auto;
}
.writeCpn_stepCon,
.writeCpn_stepCon .v-stepper__items>.v-stepper__content>.v-stepper__wrapper,
.writeCpn_stepCon .v-stepper__items>.v-stepper__content>.v-stepper__wrapper>.row {height: 100%;}
.writeCpn_stepCon .write_conYscroll{padding: 20px 10px 0 !important; height: 100%; overflow-y: auto;}
</style>
